var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppBgYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 275,
    viewBox: "0 0 275 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137.098,
    cy: 137.808,
    r: 137.011,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0148 187.545L62.1302 187.352L65.0549 182.256C57.2121 169.076 53.0174 153.976 53.0174 138.21C53.0174 115.234 61.907 93.6365 78.0545 77.3901C94.2021 61.1437 115.668 52.1996 138.504 52.1996C161.34 52.1996 182.806 61.1437 198.953 77.3901C215.101 93.6365 223.99 115.234 223.99 138.21C223.99 153.968 219.788 169.076 211.953 182.256L214.877 187.352L215.709 188.807L229.016 212C245.264 191.851 255 166.18 255 138.217C254.992 73.4795 202.832 21 138.496 21C74.16 21 22 73.4795 22 138.21C22 166.172 31.7362 191.851 47.9838 211.992L62.0148 187.545Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.0865173,
    y1: 0.796875,
    x2: 274.109,
    y2: 274.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBgYellow);
export default __webpack_public_path__ + "static/media/app-bg-yellow.04891fed8f7b04713056c8c07d1ae7b8.svg";
export { ForwardRef as ReactComponent };